import { PROFILE_STATUS, useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { Box, Flex, SimpleGrid } from '@mantine/core';
import { ProfileStepperItem } from './ProfileStepperItem';
import { ProfileStepperStatus } from './ProfileStepperStatus';
const steps = [{
  title: 'REGISTRATION',
  itemStatus: PROFILE_STATUS.REGISTRATION,
  success: PROFILE_STATUS.REGISTRATION
}, {
  title: 'VERIFY EMAIL',
  itemStatus: PROFILE_STATUS.VERIFY,
  success: PROFILE_STATUS.VERIFY
}, {
  title: 'COMPLETE PROFILE',
  itemStatus: PROFILE_STATUS.COMPLETE,
  success: PROFILE_STATUS.COMPLETE
}, {
  title: 'ID VERIFICATION',
  itemStatus: PROFILE_STATUS.VERIFICATION,
  success: PROFILE_STATUS.VERIFICATION
}];
export const ProfileStepper: React.FC = () => {
  const {
    successes
  } = useVerifyProfile();
  return <Flex direction={{
    base: 'column-reverse',
    lg: 'column'
  }} w="100%" align="center" justify="center" pos="absolute" bottom={0} left={0} right={0} style={{
    zIndex: 300
  }}>
      {!successes.has(PROFILE_STATUS.VERIFICATION) && <Box w={{
      base: '100%',
      lg: 1006
    }} bg={{
      base: 'var(--bg-300)',
      lg: 'transparent'
    }} p={15}>
          <ProfileStepperStatus hidden="sm" />

          <SimpleGrid cols={4} spacing={2}>
            {steps.map(item => <ProfileStepperItem key={item.title} {...item} />)}
          </SimpleGrid>
        </Box>}

      <ProfileStepperStatus visible="sm" />
    </Flex>;
};